var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('Banner',{staticClass:"banner",attrs:{"title":_vm.$t('Errors'),"status":"warning"}},[_vm._v(" "+_vm._s(_vm.$t('validation.bannerErrorMessage'))+" ")]):_c('Banner',{staticClass:"banner",attrs:{"title":_vm.$t('validation.bannerValidTitle'),"status":"info"}},[_vm._v(" "+_vm._s(_vm.$t('validation.bannerValidMessage'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }